import * as React from 'react';
import ProfileDropDown from '../ProfileDropDown';
import { ProfileStateType } from '../../services/studentActions/profile/state';

interface EntranceHeaderProps {
    user?: ProfileStateType;
    disableProfile?: boolean;
}
class EntranceHeader extends React.Component<EntranceHeaderProps> {
    render() {
        const { user } = this.props;
        return (
            <header role="top-nav">
                <nav role="top-navbar">
                    <div className="navbar-content">
                        <div className="logo">
                            <img src="/images/fuseai-logo.svg" alt="" />
                        </div>
                        {user && <ProfileDropDown additionaClass={'profile-list'} disableProfile={this.props.disableProfile} />}
                    </div>

                </nav>

            </header>

        );
    }
}

export default EntranceHeader;